import useRequestStore from './Request/requestStore';
import useStepsStore from './Steps/stepsStore';
import useFormStore from './Form/formStore';
import useModalStore from './Modal/modalStore';
import useOtpStore from './Otp/otpStore';
import useIconsStore from './Icons/iconsStore';
import useTemplateStore from './Template/templateStore';

const Store = {
  useRequestStore,
  useStepsStore,
  useFormStore,
  useModalStore,
  useOtpStore,
  useIconsStore,
  useTemplateStore,
};

export default Store;
